var lsConfiguration = {

    prefix: '',
    locale: 'pt-BR',
    dateFormat: 'dd/MM/yyyy',
    currencyCentSeparator: ',',
    licenseWebPKI: 'AkMBY3RzdWwucmVkZWltYWdlbS5jb20uYnIsZnVocm9zb3V0by5yZWRlaW1hZ2VtLmNvbS5icixnZWQtaG1sLmhjcGEuZWR1LmJyLGdlZC5oY3BhLmVkdS5icixnaGMucmVkZWltYWdlbS5jb20uYnIsaGJzYy5yZWRlaW1hZ2VtLmNvbS5icixoc2ZwLnJlZGVpbWFnZW0uY29tLmJyLGpvcm5hbGNvbWVyY2lvLnJlZGVpbWFnZW0uY29tLmJyLGxpcXVpZHN1aXRlaG9tb2xvZ2FjYW8ucmVkZWltYWdlbS5jb20uYnIsb2VzdGVtZWQucmVkZWltYWdlbS5jb20uYnIsc3BkYXRhLnJlZGVpbWFnZW0uY29tLmJyLHVuaW1lZHNlcnJhZ2F1Y2hhLXNlZGUucmVkZWltYWdlbS5jb20uYnKHAGlwNDoxMC4wLjAuMC84LGlwNDoxMC4wLjAuMC84LGlwNDoxMjcuMC4wLjAvOCxpcDQ6MTI3LjAuMC4wLzgsaXA0OjE3Mi4xNi4wLjAvMTIsaXA0OjE3Mi4xNi4wLjAvMTIsaXA0OjE5Mi4xNjguMC4wLzE2LGlwNDoxOTIuMTY4LjAuMC8xNgMAUHJvAAAAAVSFGuQrfUlMm3MN8vQiYgYyMJDjhB4CmIp5qDEqZSqEf/uLyyHWG3+b58HAiGmshAAejy+w9mx7btvexQh8eEnrhHtlisbibjkA2wuBAeXPWHfLujT9fMr1f1kfEu1t+P3cpr08VdzEB199UVor1YAmYDUjRLwBwOiskVNpGTkMF+kGp/MWskIY7NMKzj6pyan29abUd0WS0HYPNgt4MDkcBPfqJeTZV7y1Uyk3ebeNHeZU4h4AxDuIE5KGNqhqZUpCj28kvBLBYp7/nmSF821l/77FNvKxhFmFyLDgBTGbT3WvT2RToSiqAfl7znfJ9Y6l6TAxGpwIfYLhkNgvHHc=',
    viewer: false,
    id: 0,

    localeMoment: 'pt-br',
    dateFormatMoment: 'DD/MM/YYYY',
    timeFormatMoment: 'HH:mm:ss',

    loginTela: 'login-tela.png',

    webPkiDomains: [
        "ged.hcpa.edu.br",
        "ghc.redeimagem.com.br",
        "liquidsuitehomologacao.redeimagem.com.br",
        "ged-hml.hcpa.edu.br",
        "jornalcomercio.redeimagem.com.br",
        "fuhrosouto.redeimagem.com.br",
        "unimedserragaucha-sede.redeimagem.com.br",
        "ctsul.redeimagem.com.br",
        "hbsc.redeimagem.com.br",
        "hsfp.redeimagem.com.br",
        "oestemed.redeimagem.com.br",
        "spdata.redeimagem.com.br"
    ],
};
